import React from "react";

import Google from "../../assets/Google.png"
import logo from "../../assets/logo.png"

export const GoogleLogo = (height, width) => {
    return (
        <img src={Google} alt="Google logo" height={height} width={width} />
    )
}

export const Logo = (height, width) => {
    return (
        <img src={logo} alt="Logo" height={height} width={width} />
    )
}